import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ensureAnalytics, trackPageView, isAnalyticsPublicPath } from '@/lib/analytics';

/**
 * Loads GA4 and sends page_view only on public marketing/auth routes.
 * Skips logged-in dashboards entirely.
 */
export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (!isAnalyticsPublicPath(path)) return;

    ensureAnalytics(path);
    // Small delay so gtag script can attach before first event on cold load
    const t = setTimeout(() => {
      trackPageView(path + (location.search || ''), document.title);
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
}
